const ROUTES = {
  HOME: "/",
  // MINI_PROGRAM: "/mini-programa",
  // MIDI_PROGRAM: "/midi-programa",
  // MAXI_PROGRAM: "/maxi-programa",
  CHECKOUT: "/checkout",
  LOGIN: "/prisijungti",
  // LOGOUT: "/logout",
  REGISTER: "/registracija",
  REGISTER_ALIAS: "/register",
  RESET_PASSWORD: "/reset-password",
  // REGISTRATION_COMPLETE: "/registracija-baigta",
  PRIVACY_POLICY: "/privatumo-politika",
  COOKIES_POLICY: "/slapuku-politika",
  // EPIGENETICS_TEST: "/epigenetikos-ištyrimas",
  // GENETICS_TEST: "/issamus-genetinis-tyrimas",
  // GENOME_TESTING: "/viso-genomo-tyrimas",
  // SUPPLEMENTS: "/personalizuoti-papildai",
  // AGE_SLOWING_TEST: "/senejimo-letinimo-tyrimas",
  ACCOUNT: "/paskyra",
  DASHBOARD: "/dashboard",
  RESULTS: "/results",
  CONNECTIVITY: "/connectivity",
  ADVERTORIAL_ARTICLE:
    "/tinklarastis/kodel-du-zmones-treniruojasi-vienodai-bet-genetika-nulemia-skirtingus-rezultatus",
  ADVERTORIAL_TO_CONSULT:
    "/tinklarastis/kodel-du-zmones-treniruojasi-vienodai-bet-genetika-nulemia-skirtingus-rezultatus",
  // TYPEFORM_COMPLETED: "/typeform", //used for tracking Typeform quizes
  // KLAVIYO_FORM: "/klaviyo-form", //used for testing klaviyo forms
  // NEWSLETTER_SUCCESS: "/naujienlaiškis-užprenumeruotas",
  // REGISTER_FOR_SERVICE: "/registracija-paslaugai",
  VERIFY_EMAIL: "/verify-email",
  GOOGLE_CALLBACK: "/google-callback",
  // USER_ADDITIONAL_INFO: "/paskyros-informacija",
  GIFT_COUPON: "/dovanu-kuponas",
  // BLOOD_TEST: "/platus-kraujo-ištyrimas",
  FORGOT_PASSWORD: "/pamirsau-slaptazodi",
  // ACCEPT_INVITATION: "/accept-invitation",
  CONTACTS: "/kontaktai",
  MEMBERSHIPS: "/narystes",
  FAQ: "/duk",
  CONSULTATION: "/konsultacija",
  REZUS_REGISTRATION: "/registracija-meginiu-pridavimui/:token",
  BLOG: "/tinklarastis",
  ABOUT: "/apie-mus",
  TEAM: "/komanda",
  ES_INVESTMENT: "/es-investicija",
};

export default ROUTES;
